import { z } from 'zod';
import { DataRoomStatus } from 'further-types/data-room';
import { dataRoom } from 'further-ui/validations';

const formImageBase = z
  .object({ uri: z.string(), objectKey: z.string() })
  .nullable();

const formLogoSettings = z
  .object({
    useCustomLogo: z.boolean().optional(),
    customLogo: z
      .object({ previewUri: z.string(), objectKey: z.string() })
      .nullable()
      .optional(),
  })
  .optional();

// For Live status, the image is required — the refine puts the error directly on
// the field so fieldState.error.message is accessible without nested traversal.
const formImageLive = formImageBase.refine((val) => !!val?.objectKey, {
  message: 'Upload a contact image.',
});

export const schema = z.discriminatedUnion('status', [
  dataRoom.UpdateDataRoomLiveSchema.omit({ id: true }).extend({
    contact: dataRoom.UpdateDataRoomLiveSchema.shape.contact.extend({
      image: formImageLive,
    }),
    logoSettings: formLogoSettings,
  }),
  dataRoom.UpdateDataRoomInactiveSchema.omit({ id: true }).extend({
    contact: dataRoom.UpdateDataRoomInactiveSchema.shape.contact.extend({
      image: formImageBase,
    }),
    logoSettings: formLogoSettings,
  }),
]);

export type DataRoomFormData = z.infer<typeof schema>;

export const defaultInvestmentOpportunitiesContent = {
  title: '',
  subtitle: '',
  description: '',
  metrics: [{ fieldName: '', value: '' }],
};

export const defaultData: DataRoomFormData = {
  status: DataRoomStatus.Inactive,
  headline: '',
  subheading: '',
  contact: {
    email: '',
    image: null,
    name: '',
    phone: '',
  },
  keyInformation: [{ fieldName: '', value: '' }],
  logoSettings: {
    useCustomLogo: false,
    customLogo: null,
  },
  investmentOpportunitiesContent: defaultInvestmentOpportunitiesContent,
  legalTermsSettings: {
    requirePreAccessAgreement: false,
    useSystemDefaultAgreement: false,
    customAgreementContent: '',
    customAgreementTitle: '',
  },
};
